import styles from "./DispatchesPage.module.scss";
import type { DispatchStatus } from "./types";

/**
 * Shared dispatch status catalog: English key -> Spanish label.
 * UI order matches the backend DISPATCH_STATUSES order; labels are product-exact.
 */
export const statusLabels: Record<DispatchStatus, string> = {
  order_preparation: "Prealistamiento de pedido",
  ready_in_warehouse: "Listo en bodega",
  dispatched: "Despachado",
  product_picked: "Producto separado",
  maritime_transit: "Transito naviero",
  internal_warehouse_issue: "Novedad bodega interno",
  partial_delivery: "Entrega parcial",
};

/** Figma badge class per status (visual only, no model change) */
export const statusBadgeClass: Record<DispatchStatus, string> = {
  order_preparation: styles.statusPending,
  ready_in_warehouse: styles.statusApproved,
  dispatched: styles.statusShipped,
  product_picked: styles.statusInPreparation,
  maritime_transit: styles.statusTransit,
  internal_warehouse_issue: styles.statusIssue,
  partial_delivery: styles.statusPartial,
};

/** History actions: lifecycle actions plus every status key (matches backend DISPATCH_HISTORY_ACTIONS) */
export const actionLabels: Record<string, string> = {
  created: "Creado",
  edited: "Editado",
  approved: "Aprobado",
  ...statusLabels,
};
